export const PACKAGE_NAME =
	'@atlassian/jira-admin-pages-system-ui-announcement-banner-resources' as const;

export const PRIVACY_LEVEL_PRIVATE = 'private' as const;
export const PRIVACY_LEVEL_PUBLIC = 'public' as const;
